import React from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Dialog from 'react-toolbox/lib/dialog'
  
import styles from './styles.scss'

import { 
    dialogActiveSelector,
    dialogPageSelector,
    projectListSelector,
    projectSelectedSelector
} from 'containers/Form/Project/selectors'

import {     
    clear,
    fetchProjectSpec,
    setImportDialogActive,
    setImportDialogConfirm,
    setImportDialogDone,
    setProjectSelected
} from 'containers/Form/Project/actions'

import InitPage from './InitPage'
import ConfirmPage from './ConfirmPage'
import WaitingPage from './WaitingPage'
import DonePage from './DonePage'
import ErrorPage from './ErrorPage'
import T from 'i18n-react'

const mapStateToProps = (state) => {
    return {
      active: dialogActiveSelector(state),
      page: dialogPageSelector(state),
      projectList: projectListSelector(state),
      projectSelected: projectSelectedSelector(state)
    }
  }
  
const mapDispatchToProps = (dispatch) => {
    return {
        clear: () => dispatch(clear()),
        fetchProjectSpec: (projectId) => dispatch(fetchProjectSpec(projectId)),
        setImportDialogActive: () => dispatch(setImportDialogActive()),
        setImportDialogConfirm: () => dispatch(setImportDialogConfirm()),
        setImportDialogDone: () => dispatch(setImportDialogDone()),
    }
}

const ImportDialog = ({
    active,
    clear,
    page,
    projectSelected,
    fetchProjectSpec,
    setImportDialogActive,
    setImportDialogConfirm
}) => {

    const fetchProjectSpecFunc = () => {
        fetchProjectSpec(parseInt(projectSelected.value))
    }

    const getActions = () => {
        switch(page) {
            case 1:
                return [
                    { label: 'Next', onClick: setImportDialogConfirm, disabled: !projectSelected },
                    { label: 'Cancel', onClick: clear },
                ]
            case 2:
                return [
                    { label: 'Confirm', onClick: fetchProjectSpecFunc },
                    { label: 'Back', onClick: setImportDialogActive },
                ]
            case 4:
                return [
                    { label: 'Close', onClick: clear }
                ]
            case 5:
                return [
                    { label: 'Close', onClick: clear }
                ]
            default:
                return []
        }
    }
    
    return (
        <Dialog
        actions={getActions()}
        active={active}
        title={T.translate(`project.import.title.${page}`, { id: projectSelected ? projectSelected.value : 1 })}
        onOverlayClick={clear}
        onEscKeyDown={clear}
        theme={styles}
    > 
            {page === 1 && <InitPage />}
            {page === 2 && <ConfirmPage />}
            {page === 3 && <WaitingPage />}
            {page === 4 && <DonePage />}
            {page === 5 && <ErrorPage />}
    </Dialog>
    )
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const styledComponent = CSSModules(ImportDialog, styles)
export default withConnect(styledComponent)
